import { render } from "./roadMap.vue?vue&type=template&id=72e85c1c&scoped=true"
import script from "./roadMap.vue?vue&type=script&lang=js"
export * from "./roadMap.vue?vue&type=script&lang=js"

import "./roadMap.vue?vue&type=style&index=0&id=72e85c1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e85c1c"]])

export default __exports__